import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { evaluationDetailResolver } from './guards/evaluation-detail.resolver';
import { isEvaluatorGuard } from './guards/is-evaluator.guard';
import { postingResolver } from './guards/posting.resolver';
import { unsavedEvaluationChangesGuard } from './guards/unsaved-evaluation-changes.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'jobs', pathMatch: 'full' },
  {
    path: 'jobs',
    loadComponent: () => import('./features/postings/postings.component').then((m) => m.PostingsComponent),
    data: { shouldDetach: true },
  },
  {
    path: 'jobs/:id',
    loadComponent: () => import('./features/posting/posting.component').then((m) => m.PostingComponent),
    resolve: {
      posting: postingResolver,
    },
  },
  {
    path: 'profile',
    loadComponent: () => import('./features/profile/profile.component').then((m) => m.ProfileComponent),
    canActivate: [MsalGuard],
  },
  {
    path: 'profile/edit',
    loadComponent: () =>
      import('./features/profile/profile-editor/profile-editor.component').then((m) => m.ProfileEditorComponent),
    canActivate: [MsalGuard],
  },
  {
    path: 'portal',
    loadComponent: () => import('./features/portal/portal.component').then((m) => m.PortalComponent),
    canActivate: [MsalGuard],
  },
  {
    path: 'wallet',
    loadComponent: () => import('./features/wallet/wallet.component').then((m) => m.WalletComponent),
    canActivate: [MsalGuard],
  },
  {
    path: 'applications',
    loadComponent: () =>
      import('./features/my-applications/my-applications.component').then((m) => m.MyApplicationsComponent),
    canActivate: [MsalGuard],
  },
  {
    path: 'evaluations/:id',
    loadComponent: () =>
      import('./features/my-evaluations/evaluation-detail/evaluation-detail.component').then(
        (m) => m.EvaluationDetailComponent
      ),
    canActivate: [MsalGuard, isEvaluatorGuard],
    canDeactivate: [unsavedEvaluationChangesGuard],
    resolve: {
      evaluationDetail: evaluationDetailResolver,
    },
  },
  {
    path: 'evaluations',
    loadComponent: () =>
      import('./features/my-evaluations/pending-evaluations.component').then((m) => m.PendingEvaluationsComponent),
    canActivate: [MsalGuard, isEvaluatorGuard],
  },
  {
    path: 'settings',
    loadComponent: () => import('./features/profile/settings/settings.component').then((m) => m.SettingsComponent),
    canActivate: [MsalGuard],
  },
  {
    // This route is used in the API. Do not change it unless the API is updated as well.
    path: 'account/deletion/status',
    loadComponent: () =>
      import('./features/profile/account-deletion-status/account-deletion-status.component').then(
        (m) => m.AccountDeletionStatusComponent
      ),
  },
  {
    path: 'accessibility',
    loadComponent: () =>
      import('./shared/components/legal-notice/legal-notice.component').then((m) => m.LegalNoticeComponent),
    data: { title: 'Accessibility', legalNoticeType: 'Accessibility' },
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./shared/components/legal-notice/legal-notice.component').then((m) => m.LegalNoticeComponent),
    data: { title: 'Privacy Policy', legalNoticeType: 'PrivacyPolicy' },
  },
  {
    path: 'terms-of-use',
    loadComponent: () =>
      import('./shared/components/legal-notice/legal-notice.component').then((m) => m.LegalNoticeComponent),
    data: { title: 'Terms of Use', legalNoticeType: 'TermsOfUse' },
  },
  {
    path: 'forbidden',
    loadComponent: () => import('./shared/components/forbidden/forbidden.component').then((m) => m.ForbiddenComponent),
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('./shared/components/page-not-found/page-not-found.component').then((m) => m.PageNotFoundComponent),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/components/page-not-found/page-not-found.component').then((m) => m.PageNotFoundComponent),
  },
];
